// src/pages/Bestsellers/ProductBenefits.jsx
import React, { useState } from 'react';
import './ProductBenefits.css';

const ProductBenefits = ({ benefits }) => {
  const [failedImages, setFailedImages] = useState({});
  const [centerImageError, setCenterImageError] = useState(false);

  const defaultBenefits = {
    left: [
      {
        icon: 'https://wonder-theme-beauty.myshopify.com/cdn/shop/files/vegan_750x_58ef5fb2-516f-4752-9336-6551de1826e4.webp?v=1660643725&width=1000',
        title: 'Vegan',
        description: 'Our entire collection is vegan and cruelty free.'
      },
      {
        icon: 'https://wonder-theme-beauty.myshopify.com/cdn/shop/files/recycle_750x_70b605f7-ae03-4d7e-99d8-ce8ba29c31f0.webp?v=1660643753&width=1000',
        title: 'Recyclable',
        description: 'All packaging is recyclable and eco conscious.'
      },
      {
        icon: 'https://wonder-theme-beauty.myshopify.com/cdn/shop/files/paraben-2.png?v=1661022271&width=1000',
        title: 'Parabens Free',
        description: 'Our products do not contain harmful substances.'
      }
    ],
    right: [
      {
        icon: 'https://wonder-theme-beauty.myshopify.com/cdn/shop/files/ocean-2-ico.jpg?v=1732357942&width=1000',
        title: 'Ocean Bound Plastic',
        description: 'Support a Sustainable Future with our Environmentally Conscious Goods.'
      },
      {
        icon: 'https://wonder-theme-beauty.myshopify.com/cdn/shop/files/natur_750x_fc1dfda5-9070-4a1e-88b4-6ca01aa87c15.webp?v=1660643741&width=1000',
        title: 'Natural',
        description: 'We only use the finest natural ingredients.'
      },
      {
        icon: 'https://wonder-theme-beauty.myshopify.com/cdn/shop/files/quebec-ico.jpg?v=1732358049&width=1000',
        title: 'Best Quality',
        description: 'Explore the Unmatched Quality of Products.'
      }
    ]
  };

  const displayBenefits = benefits && (benefits.left?.length > 0 || benefits.right?.length > 0)
    ? benefits
    : defaultBenefits;

  const getFirstBenefitImage = () => {
    if (displayBenefits.left && displayBenefits.left.length > 0) {
      return displayBenefits.left[0].icon;
    }
    if (displayBenefits.right && displayBenefits.right.length > 0) {
      return displayBenefits.right[0].icon;
    }
    return 'https://wonder-theme-beauty.myshopify.com/cdn/shop/files/bkind-anim.gif?v=1732356650&width=2000';
  };

  const getLeftBenefitsExcludingFirst = () => {
    if (!displayBenefits.left || displayBenefits.left.length === 0) {
      return [];
    }
    return displayBenefits.left.slice(1);
  };

  const handleImageError = (index, column) => {
    setFailedImages(prev => ({
      ...prev,
      [`${column}-${index}`]: true
    }));
  };

  const handleCenterImageError = () => {
    setCenterImageError(true);
  };

  const getFallbackIcon = (title) => {
    const titleLower = title.toLowerCase();
    if (titleLower.includes('vegan')) return '/icons/vegan.svg';
    if (titleLower.includes('recycl')) return '/icons/recyclable.svg';
    if (titleLower.includes('paraben')) return '/icons/check.svg';
    if (titleLower.includes('ocean')) return '/icons/check.svg';
    if (titleLower.includes('natural')) return '/icons/organic.svg';
    if (titleLower.includes('quality')) return '/icons/check.svg';
    return '/icons/check.svg';
  };

  const defaultCenterImage = 'https://wonder-theme-beauty.myshopify.com/cdn/shop/files/bkind-anim.gif?v=1732356650&width=2000';
  const centerImageUrl = centerImageError ? defaultCenterImage : getFirstBenefitImage();
  const leftBenefits = getLeftBenefitsExcludingFirst();

  return (
    <>
      <link
        href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css"
        rel="stylesheet"
      />

      <div className="product-benefits-section">
        <div className="container">
          <h2 className="section-title-1">Product Benefits</h2>

          <div className="benefits-wrapper">
            <div className="row align-items-center g-0">

              {/* Left Benefits */}
              <div className="col-md-4">
                <div className="benefits-column left-column">
                  {leftBenefits.map((benefit, index) => (
                    <div key={`left-${index}`} className="benefit-item left-item">
                      <div className="benefit-icon">
                        <img
                          src={failedImages[`left-${index}`] ? getFallbackIcon(benefit.title) : benefit.icon}
                          alt={benefit.title}
                          onError={() => handleImageError(index, 'left')}
                          loading="lazy"
                        />
                      </div>
                      <div className="benefit-text">
                        <h3 className="benefit-title">{benefit.title}</h3>
                        <p className="benefit-desc">{benefit.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Center Image */}
              <div className="col-md-4">
                <div className="center-image-container">
                  <img
                    src={centerImageUrl}
                    alt="Product Benefits Center"
                    loading="lazy"
                    onError={handleCenterImageError}
                    className="center-image-fixed"
                  />
                </div>
              </div>

              {/* Right Benefits */}
              <div className="col-md-4">
                <div className="benefits-column right-column">
                  {displayBenefits.right.map((benefit, index) => (
                    <div key={`right-${index}`} className="benefit-item right-item">
                      <div className="benefit-icon">
                        <img
                          src={failedImages[`right-${index}`] ? getFallbackIcon(benefit.title) : benefit.icon}
                          alt={benefit.title}
                          onError={() => handleImageError(index, 'right')}
                          loading="lazy"
                        />
                      </div>
                      <div className="benefit-text">
                        <h3 className="benefit-title">{benefit.title}</h3>
                        <p className="benefit-desc">{benefit.desc || benefit.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductBenefits;